import cookie from 'js-cookie';
import { connect } from 'react-redux';
import { Button, message } from 'antd';
import GoogleLogin from 'react-google-login';
import { withRouter } from 'react-router-dom';
import React, { Fragment } from 'react';

import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

import {
  actionGetProfile,
  actionShowLoading,
  actionHideLoading,
} from '../../features/system/actions';
import { getUserAffiliationInfo } from '../../features/dashboard/actions';
import { LoginAccountViaFbGg } from '../../features/login/actions';

import {
  routes,
  TOKEN,
  socialAccount,
  CONFIG_SERVER,
} from '../../utils/constants/constant';

import { IconGoogle, IconFacebook } from '../../assets/index';
import './ButtonLogin.scss';

const ButtonLoginViaGGFB = ({
  isLogin = true,
  history,
  actionGetProfile,
  actionHideLoading,
  actionShowLoading,
  redirectUri = 'https://doitac.mytour.vn/',
}) => {
  const responseOnSuccessGoogle = async (response) => {
    const dataViaFbGg = {
      access_token: response.tokenId || '',
      provider: 'google',
    };
    handleOauth(dataViaFbGg);
  };

  const responseOnFailureGoogle = (response) => {};

  const responseFacebook = async (response) => {
    if (response.status === 'unknown' || response.status === 'not_authorized') {
    } else {
      const dataViaFbGg = {
        access_token: response.accessToken || '',
        provider: 'facebook',
      };
      handleOauth(dataViaFbGg);
    }
  };

  const handleOauth = async (dataViaFbGg = {}) => {
    try {
      let deviceId = null;
      const key = `${CONFIG_SERVER.NEXT_PUBLIC_APP_ID}_v2021-05-03`;
      deviceId = `${new Date().valueOf()}-${Math.random()}`;
      const value = localStorage.getItem(key);
      if (value === null) {
        localStorage.setItem(key, deviceId);
      } else {
        deviceId = value;
      }
      const dataDTO = {
        ...dataViaFbGg,
        device_id: deviceId,
      };
      actionShowLoading();
      const { data } = await LoginAccountViaFbGg(dataDTO);
      if (data.code === 200) {
        getToken(data);
      } else {
        actionHideLoading();
        data?.message && message.error(data?.message);
      }
    } catch (error) {
      actionHideLoading();
    }
  };
  // cookie.set(TOKEN, '3b7239bc-83f8-43a5-8709-c1c4599dcedf', { expires: 182 });
  const getToken = async (values) => {
    try {
      const { data } = await getUserAffiliationInfo({
        //eslint-disable-next-line
        ['login_token']: `${values.access_token}`,
      });
      actionHideLoading();
      if (data.code === 200) {
        cookie.set(TOKEN, values.access_token, { expires: 182 });
        if (isLogin) {
          message.success('Đăng nhập thành công!');
        } else {
          message.success('Đăng ký tài khoản thành công!');
        }
        history.push(`${routes.DASHBOARD}`);
        actionGetProfile();
      } else {
        data?.message && message.error(data?.message);
      }
    } catch (error) {
      actionHideLoading();
    }
  };

  return (
    <Fragment>
      <FacebookLogin
        appId={socialAccount.facebook_id}
        callback={responseFacebook}
        redirectUri={redirectUri}
        disableMobileRedirect={true}
        fields='name,email,picture'
        render={(renderProps) => (
          <Button onClick={renderProps.onClick} className='btn-login-via'>
            <IconFacebook />
            <span className='text-btn'>
              {isLogin ? 'Đăng nhập bằng Facebook' : 'Đăng ký bằng Facebook'}
            </span>
          </Button>
        )}
      />
      <GoogleLogin
        clientId={socialAccount.gg_plus_id}
        buttonText='Login'
        onSuccess={responseOnSuccessGoogle}
        onFailure={responseOnFailureGoogle}
        cookiePolicy={'single_host_origin'}
        render={(renderProps) => (
          <Button
            onClick={renderProps.onClick}
            className='btn-login-via btn-login-via-gg'
          >
            <IconGoogle />
            <span className='text-btn'>
              {isLogin ? 'Đăng nhập bằng Google' : 'Đăng ký bằng Google'}
            </span>
          </Button>
        )}
      />
    </Fragment>
  );
};

export default connect((state) => ({}), {
  actionGetProfile,
  actionShowLoading,
  actionHideLoading,
})(withRouter(ButtonLoginViaGGFB));
